import React, { useContext } from 'react';
import { Card, Segment } from 'semantic-ui-react';
import { getSectionClass } from '../styles/formatting';
import { ParentContext } from '../cnr/contexts/ParentContext';

const GenericProfile = (props) => {

  const { formData, subKey } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}

  // papsContext    
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { uiElements } = aps_global ?? {}
  let { card, meta, header } = uiElements ? uiElements : { card: {}, list: {} }

  const cn_card = subKey === 'card' ? getSectionClass('', formData) : getSectionClass('', card)
  const cn_header = subKey === 'header' ? getSectionClass('', formData) : getSectionClass('', header)
  const cn_meta = subKey === 'meta' ? getSectionClass('', formData) : getSectionClass('', meta)

  const headerLine = (value) => <div className="prc">
    <div className="prp-firstName">{value}</div>
  </div>

  return <Segment>
    <Card fluid className="card-profile preview" {...cn_card}>
      <Card.Content>
        <Card.Header className={cn_header}>
          {headerLine('Header')}
        </Card.Header>
        <Card.Meta className={cn_meta}>
          <div>Meta</div>
        </Card.Meta>
      </Card.Content>
    </Card>
  </Segment>
};

export default GenericProfile